import { computed, defineComponent, onMounted, onUnmounted, onUpdated, PropType, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { ProjectAction, ProjectGetter } from '@/store/project/project.module';
import { Project, ProjectSearch } from '@/store/project/project.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import projectService from '@/store/project/project.service';

export default defineComponent({
  name: 'ProjectTableComponent',
  components: {
    LoadingComponent
  },
  props: {
    mode: {
      type: String
    },
    userId: {
      type: String
    },
    filter: {
      type: Object as PropType<ProjectSearch>
    }
  },
  setup: (props) => {
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);
    const projects = computed<Project[]>(() => store.getters[ProjectGetter.ALL]);
    const isLoading = computed(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(ProjectAction.CLEAR)
        .then(() => initialDataTable());
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    // popover
    onUpdated(() => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-project"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    });

    const search = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
            store.dispatch(ProjectAction.SEARCH, {
              fiscalYearId: props.filter?.fiscalYearId,
              userId: props.userId,
              mode: props.mode,
              projectName: props.filter?.keyword,
              cabinetId: props.filter?.cabinetId,
              cabinetMinisterId: props.filter?.cabinetMinisterId,
              provinceId: props.filter?.provinceId,
              projectTypeId: props.filter?.projectTypeId,
              budgetTypeId: props.filter?.budgetTypeId,
              projectStatusKey: props.filter?.projectStatusKey,
            }).then(() => initialDataTable());
        });
    };

    const selectedClick = (projectId: number) => {
      Promise.resolve(popoverList.value.map(element => element.hide()))
        .then(() => router.push(`/project/${projectId}`));
    };

    const excelClick = () => {
      projectService.SearchToExcel(
        props.filter?.fiscalYearId as number,
        props.userId as string,
        props.mode as string,
        props.filter?.keyword as string,
        props.filter?.cabinetId as number,
        props.filter?.cabinetMinisterId as number,
        props.filter?.provinceId as number,
        props.filter?.projectTypeId as number,
        props.filter?.budgetTypeId as number,
        props.filter?.projectStatusKey as number,
      )
        .then((response) => {
          const a = document.createElement('a'); //Create <a>
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = window.URL.createObjectURL(response.data); //'data:pdf/application;base64,' + response.data; //Image Base64 Goes here
          a.download = ('ข้อมูลโครงการ.xlsx'); //File name Here
          a.click(); //Downloaded file
        })
        .catch(() => {
          toast.error('ไม่สามารถเรียกข้อมูลได้');
        });
    };

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
      if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
      }
    };

    return {
      projects,
      datatable,
      isLoading,
      search,
      selectedClick,
      excelClick,
    };
  },
});
